// extracted by mini-css-extract-plugin
export var colorSquare = "_o0-0";
export var danger = "_o0-5";
export var lightPink = "_o0-8";
export var neutralBlue = "_o0-7";
export var neutralYellow = "_o0-6";
export var normal = "_o0-1";
export var primary = "_o0-2";
export var primaryLight = "_o0-3";
export var solidBlack = "_o0-g";
export var solidGreen = "_o0-b";
export var solidLightBlue = "_o0-d";
export var solidNavy = "_o0-c";
export var solidOrange = "_o0-f";
export var solidPink = "_o0-e";
export var solidRed = "_o0-9";
export var solidYellow = "_o0-a";
export var success = "_o0-4";